// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { getPlanLocationFromLocation } from '../location_helpers';
import {
  HOME_CHANGE_ASSIGNMENT,
} from './constants';

function getModifiedAssignments(scheduleAssignments, plans, worker, date, location, roles, locked) {
  return scheduleAssignments.map(sa => {
    if (sa.workerId === worker.id && (sa.date === date))
    {
      let newSa = {...sa, dirty:true};
      if (location !== undefined)
      {
        newSa.location = location;
        if (location === null || location === "")
        {
          newSa.planId = null;
        }
        else
        {
          newSa.planId = Object.values(plans).filter(p => p.date === newSa.date &&  p.location === getPlanLocationFromLocation(location));
        
          if (newSa.planId.length !== 1)
            throw new Error("found " + newSa.planId.length + " matching plans :-( ");
          newSa.planId = newSa.planId[0].id;
        }
        
      }
      if (roles !== undefined)
        {
          newSa.roles = roles;
        }      
      if (locked !== undefined)
      {
        newSa.locked = locked;
      }
      return newSa;
    }
    return sa;
  });

}

export function changeAssignment(schedule, plans, worker, date, location, roles, locked) {
  return {
    type: HOME_CHANGE_ASSIGNMENT,
    data: {schedule, plans,worker, date, location, roles, locked}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CHANGE_ASSIGNMENT:
      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          [action.data.schedule.id]: {
            ...action.data.schedule,
            scheduleAssignments:
              getModifiedAssignments(action.data.schedule.scheduleAssignments,
                action.data.plans,
               action.data.worker, 
               action.data.date, 
               action.data.location,
               action.data.roles,
               action.data.locked)

            
          }
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/changeAssignment.js